import { render } from "./SelectFiat.vue?vue&type=template&id=6823451b&scoped=true"
import script from "./SelectFiat.vue?vue&type=script&lang=js"
export * from "./SelectFiat.vue?vue&type=script&lang=js"

import "./SelectFiat.vue?vue&type=style&index=0&id=6823451b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6823451b"]])

export default __exports__